<template>
  <div class="undo-redo-container">
    <BbBtn
      size="x-small"
      type="icon"
      icon="undo"
      icon-size="small"
      no-background
      @click="undo"
      :is-disabled="!canUndo"
    />
    <BbBtn
      size="x-small"
      type="icon"
      icon="redo"
      icon-size="small"
      no-background
      @click="redo"
      :is-disabled="!canRedo"
    />
  </div>
</template>

<script>
import createHtmlHistory from '~/composables/createHtmlHistory';

export default {
  emits: ['onUndo', 'onRedo'],
  setup(props, { emit }) {
    const { canUndo, canRedo } = createHtmlHistory();

    const undo = () => {
      emit('onUndo');
    };

    const redo = () => {
      emit('onRedo');
    };

    return {
      undo,
      redo,
      canRedo,
      canUndo,
    };
  },
};
</script>

<style lang="scss" scoped>
.undo-redo-container {
  width: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: $bb-neutral-0;
  border: 1px solid $bb-neutral-4;
  border-radius: 100px;
  padding: $bb-spacing-2 $bb-spacing-4;
  height: $bb-spacing-9;

  @include media-breakpoint-up('lg') {
    left: 30%;
    right: 70%;
  }
}
</style>
